import './Logo.scss';

export default function Logo() {
  return (
    <div className="Logo">
      <img src={'/logo512.png'} className="Logo" alt="logo" />
    </div>
  )
}